import {toUrl} from "@/utils/textUtilities";
import {isTrue} from "@/utils/service/DocumentGeneration/answers";
import {isValueDefaultValueOfQuestion} from "@/utils/service/DocumentGeneration";
import questions_lt_v1 from "./questions_lt_v1"

export function transform(model) {
    // console.log("transform", model);
    let include = [];
    let params = {
        company: model.company,
        website_url: toUrl(model.website_url),
        dispute_resolution: {
            via_arbitration: model.disputeResolution.type === "arbitration",
            country: model.disputeResolution.country,
        },
    };

    // console.log(model.privacyPolicy.use);

    if (isTrue(model.privacyPolicy.use)) {
        include.push("privacy_policy");
        if(model.privacyPolicy.link === "include_privacy_policy_from_project") {
            params['include_privacy_policy_from_project'] = true;
            params.privacy_policy_link = "";
        } else {
            params.privacy_policy_link = toUrl(model.privacyPolicy.link);
        }
    }

    if (isTrue(model.paymentPolicy.services)) {
        include.push("paid_services");
        if (isTrue(model.paymentPolicy.refund)) {
            if (isTrue(model.paymentPolicy.have_refund_policy)) {
                if (
                    model.paymentPolicy.refund_policy_link ===
                    "include_refund_policy_from_project"
                ) {
                    params["include_refund_policy_from_project"] = true;
                    params.refund_policy_link = "";
                } else {
                    params.refund_policy_link = toUrl(
                        model.paymentPolicy.refund_policy_link
                    );
                }
                include.push("paid_services_refund_policy");
            } else {
                params["refund_issue_period_in_days"] =
                    model.paymentPolicy.refundProcessDays !== "other"
                        ? model.paymentPolicy.refundProcessDays
                        : model.paymentPolicy.refundProcessDays_other;

                params["refund_request_period_in_days"] =
                    model.paymentPolicy.refundRequestDays !== "other"
                        ? model.paymentPolicy.refundRequestDays
                        : model.paymentPolicy.refundRequestDays_other;
            }
        } else {
            include.push("paid_services_non_refundable");
        }
    }

    if (isTrue(model.additional_clauses_use) && model.additional_clauses?.length > 0) {
        params["additional_sections"] = model.additional_clauses;
    }

    if (isTrue(model.userAccounts)) include.push("use_of_user_accounts");

    if (isTrue(model.userGeneratedContent)) include.push("use_of_user_content");

    if (isTrue(model.thirdPartyWebsites))
        include.push("links_to_third_parties");

    return {
        ...params,
        include,
    };
}

export function retransform(params) {
    let paymentPolicy = {
        services: params.include.includes("paid_services"),
        refund: !params.include.includes("paid_services_non_refundable"),
        have_refund_policy: params.include.includes(
            "paid_services_refund_policy"
        ),
        refund_policy_link: params.refund_policy_link,
        refundRequestDays: params.refund_issue_period_in_days,
        refundProcessDays: params.refund_request_period_in_days,
    };

    // Solve Refund Request Period
    if(isValueDefaultValueOfQuestion(params.refund_request_period_in_days, "paymentPolicy.refundRequestDays", questions_lt_v1)) {
        paymentPolicy.refundRequestDays = params.refund_request_period_in_days;
    } else {
        paymentPolicy.refundRequestDays = "other";
        paymentPolicy.refundRequestDays_other = params.refund_request_period_in_days;
    }

    // Solve Refund Issue Period
    if(isValueDefaultValueOfQuestion(params.refund_issue_period_in_days, "paymentPolicy.refundProcessDays", questions_lt_v1)) {
        paymentPolicy.refundProcessDays = params.refund_issue_period_in_days;
    } else {
        paymentPolicy.refundProcessDays = "other";
        paymentPolicy.refundProcessDays_other = params.refund_issue_period_in_days;
    }

    return {
        ...params,

        disputeResolution: {
            type: params.dispute_resolution.via_arbitration
                ? "arbitration"
                : "court",
            country: params.dispute_resolution.country,
        },

        additional_clauses_use:
            params.additional_sections?.length > 0 || false,
        additional_clauses: params.additional_sections,

        privacyPolicy: {
            use: params.include.includes("privacy_policy"),
            link: params.privacy_policy_link,
        },
        userGeneratedContent: params.include.includes("use_of_user_content"),
        thirdPartyWebsites: params.include.includes("links_to_third_parties"),
        userAccounts: params.include.includes("use_of_user_accounts"),
        paymentPolicy
    };
}
